import { useContext } from "react";
import RegularClassContext from "src/context/regularClassContext.js";

const useRegularClass = () => {
  const value = useContext(RegularClassContext);
  return value;
};

export default useRegularClass;
